<template>
  <div class="new-back pa-3 fill-height">

    <filter-search-input v-model="filters.search" :applied-filters="appliedFilters" outlined dense>
      <q-user-autocomplete
        v-model="filters.users"
        label="People"
        :items="users"
        multiple
        show-number-of-selection
        hide-details
        dense
        outlined 
        clearable
        :confirmable="false"
      />
      <v-select
        hide-details
        class="input"
        :items="departments"
        multiple
        label="Department"
        item-value="value"
        item-text="name"
        v-model="filters.department"
        outlined
        dense
        clearable
      />
      <v-switch class="input" inset label="Only Active" v-model="filters.onlyActive"></v-switch>
    </filter-search-input>

    <v-data-table
      class="rounded-lg bordered new-back lighten2"
      :items="recessDays"
      :headers="headers"
      @click:row="getUserRecessReport"
      :item-class="() => 'cursor-pointer'"
    >
      <template #[`item.blueniversary`]="{ item }">
        {{ item.blueniversary | formatDate }}
      </template>
      <template #[`item.totalRecessDays`]="{ item }">
        <v-menu
          open-on-hover
          class="menu "
          v-if="item.recessDays.length"
        >
          <template #activator="{ on }">
            <span v-on="on" style="max-width: 60px;">
              {{ item.totalRecessDays }}
            </span>
          </template>
          <v-list
            dense
            style="min-width: 200px;"
            class="new-back"
          >
            <v-list-item>
              <div
                class="d-flex justify-space-between align-center"
                style="min-width: 20px; width: 100%"
              >
                <span
                  class="mr-6"
                >
                  Days
                </span>
                <span>
                  Date
                </span>
              </div>
            </v-list-item>
            <v-list-item
              v-for="(recessDay, ix) in item.recessDays"
              :key="ix"
              class=""
            >
              <div
                class="d-flex justify-space-between align-center"
                style="min-width: 20px; width: 100%"
              >
                <span
                  class="mr-6"
                >
                  {{ recessDay.days }}
                </span>
                <span>
                  {{ recessDay.createdAt | formatDate }}
                </span>
              </div>
            </v-list-item>
          </v-list>
        </v-menu>
        <div v-else>
          {{ item.totalRecessDays }}
        </div>
      </template>
      <template #[`item.totalDaysRequested`]="{ item }">
        <v-menu
					:nudge-left="112" open-on-hover
					class="menu"
				>
          <template #activator="{ on }">
            <span v-on="on" style="max-width: 60px; ">
              {{ item.totalDaysRequested }}
            </span>
          </template>
					<v-data-table
						v-if="true"
						:headers="requestHeaders"
						:items="item.recessRequests"
						class="new-back" :height="item.recessRequests.length > 4 ? 200 : 'auto'"
						disable-pagination hide-default-footer fixed-header dense
						:options="{ sortBy: ['createdAt'], sortDesc: [true] }"
					>
						<template #[`item.lines`]="{ item }">
							{{ item.lines.length }}
						</template>
						<template #[`item.type`]="{ item }">
							{{ types.find(t => t.id == item.type) ? types.find(t => t.id == item.type).name : '' }}
						</template>
						<template #[`item.createdAt`]="{ item }">
							{{ item.createdAt | formatDate }}
						</template>
					</v-data-table>
        </v-menu>
      </template>
    </v-data-table>

    <v-dialog v-model="showModal" max-width="1000" scrollable>
      <v-card class="new-back">
        <v-card-title class="d-flex justify-space-between align-center">
          <div>
            <h3 class="text-h6">{{ selectedUser ? selectedUser.fullName : '' }}</h3>
            <div class="caption text--secondary">
              <span class="mr-4"><strong>Bluetag:</strong> {{ selectedUser ? selectedUser.blueTag : '' }}</span>
              <span><strong>Bluenniversary:</strong> {{ selectedUser ? selectedUser.blueniversary : '' | formatDate }}</span>
            </div>
          </div>
          <v-btn icon @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="selectedUser" class="pa-4">
          <v-data-table
            :headers="recessReportHeaders"
            :items="recessReportData"
            class="new-back"
            disable-pagination
            hide-default-footer
            dense
            :options="{ sortBy: ['date'], sortDesc: [false] }"
          >
            <template #[`item.date`]="{ item }">
              {{ item.date | formatDate }}
            </template>
            <template #[`item.type`]="{ item }">
              <v-chip
                v-if="item.type"
                :color="getTypeColor(item.type)"
                small
                outlined
              >
                {{ item.type }}
              </v-chip>
            </template>
            <template #[`item.comments`]="{ item }">
              {{ item.comments || '' }}
            </template>
            <template #[`item.accrued`]="{ item }">
              {{ item.accrued !== null && item.accrued !== undefined ? item.accrued : '' }}
            </template>
            <template #[`item.approved`]="{ item }">
              {{ item.approved !== null && item.approved !== undefined ? item.approved : '' }}
            </template>
            <template #[`item.balance`]="{ item }">
              <strong>{{ item.balance }}</strong>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeModal">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      filters: {
        users: [],
        department: [],
        onlyActive: true,
      },
      users: [],
      items: [],
      headers: [
        { text: 'BlueTag', value: 'blueTag' },
        { text: 'Name', value: 'fullName' },
        { text: 'Bluenniversary', value: 'blueniversary' },
        { text: 'Recess Days', value: 'totalRecessDays', align: 'right' },
        { text: 'Requested Days', value: 'totalDaysRequested', align: 'right' },
        { text: 'Available Days', value: 'availableDays', align: 'right' },
      ],
      departments: [
        { value: 1, name: 'Administration' },
        { value: 5, name: 'Capability Management' },
        { value: 2, name: 'Sales' },
        { value: 0, name: 'Dev Center' },
        { value: 4, name: 'Marketing' },
        { value: 3, name: 'Talent Acquisition' },
      ],

			requestHeaders: [
				{ text: 'Days', value: 'lines' },
				{ text: 'Type', value: 'type' },
				{ text: 'Date',   value: 'createdAt' },
			],
			types: [],
			showModal: false,
			selectedUser: null,
			recessReportHeaders: [
				{ text: 'Date', value: 'date' },
				{ text: 'Type', value: 'type' },
				{ text: 'Comments', value: 'comments' },
				{ text: 'Accrued', value: 'accrued', align: 'right' },
				{ text: 'Approved', value: 'approved', align: 'right' },
				{ text: 'Balance', value: 'balance', align: 'right' },
			],
    }
  },
  computed: {
    recessReportData() {
      if (!this.selectedUser) return []
      
      const entries = []
      
      const normalizeDate = (date) => {
        const d = new Date(date)
        return new Date(d.getFullYear(), d.getMonth(), d.getDate())
      }
      
      if (this.selectedUser.recessDays && Array.isArray(this.selectedUser.recessDays)) {
        this.selectedUser.recessDays.forEach(day => {
          const normalizedDate = normalizeDate(day.createdAt)
          entries.push({
            date: normalizedDate,
            originalDate: new Date(day.createdAt),
            type: null,
            comments: '',
            accrued: day.days,
            approved: null,
            balance: 0
          })
        })
      }
      
      if (this.selectedUser.recessRequests && Array.isArray(this.selectedUser.recessRequests)) {
        const approvedRequests = this.selectedUser.recessRequests.filter(req => {
          return req.status === 2 || req.status === 'Approved'
        })
        
        approvedRequests.forEach(request => {
          const typeName = this.getTypeName(request.type)
          const comments = request.requestorComments || ''
          
          const daysCount = request.lines && Array.isArray(request.lines) ? request.lines.length : 0
          
          if (daysCount > 0) {
            let requestDate = request.createdAt
            if (request.lines && request.lines.length > 0) {
              const datesWithValues = request.lines
                .filter(line => line.date)
                .map(line => new Date(line.date))
                .sort((a, b) => a - b)
              
              if (datesWithValues.length > 0) {
                requestDate = datesWithValues[0]
              }
            }
            
            const normalizedDate = normalizeDate(requestDate)
            
            if (request.type === 2) {
              entries.push({
                date: normalizedDate,
                originalDate: new Date(requestDate),
                type: typeName,
                comments: comments,
                accrued: daysCount,
                approved: daysCount,
                balance: 0
              })
            } else {
              entries.push({
                date: normalizedDate,
                originalDate: new Date(requestDate),
                type: typeName,
                comments: comments,
                accrued: null,
                approved: daysCount,
                balance: 0
              })
            }
          }
        })
      }
      
      const chronologicalSort = (a, b) => {
        const dateA = a.date.getTime()
        const dateB = b.date.getTime()
        const dateDiff = dateA - dateB
        
        if (dateDiff !== 0) return dateDiff
        
        if (a.accrued !== null && b.accrued === null) return -1
        if (a.accrued === null && b.accrued !== null) return 1
        
        return a.originalDate.getTime() - b.originalDate.getTime()
      }
      
      const entriesForBalance = [...entries].sort(chronologicalSort)
      
      let balance = 0 
      entriesForBalance.forEach(entry => {
        if(!entry.type) {
          balance += entry.accrued
        } else if (entry.type === 'Paid Leave') {
        } else {
          balance -= entry.approved
        }
        entry.balance = balance
      })
      
      entries.sort(chronologicalSort)
      
      return entries
    },
    recessDays() {
      let items = JSON.parse(JSON.stringify(this.items))
      if(this.filters.users.length) {
        items = items.filter(x => this.filters.users.indexOf(x.id) > -1)
      }
      if(this.filters.department.length){
        items = items.filter(i => this.filters.department.includes(i.department))
      }
      if(this.filters.onlyActive){
        items = items.filter(i => i.active)
      }

      items = this.applySearch(this.filters.search, items, ['fullName', 'blueTag'])

      return items
    },
    appliedFilters() { return this.countActiveFilters(this.filters, ['search']) },
  },
  mounted() {
    document.title = 'Vacations'
    this.$q.log(7, 50, 3, 'NA')
    this.init()
  },
  methods: {
    init() {
      this.$http.get('api/recess/users/days')
        .then(res => {
          this.users = res.data
          this.items = res.data.map(this.formatUserWithDays)
        })
			this.$http.get('api/enums/recessRequestTypes')
				.then(res => {
					this.types = res.data
				})
				.catch(err => {
					console.error(err)
				})
    },
    getUserRecessReport(user) {
      this.$http.get(`api/recess/users/${user.id}/report`)
        .then(res => {
          this.selectedUser = res.data
          this.showModal = true
        })
        .catch(err => {
          console.error(err)
          this.$q.notify({
            type: 'negative',
            message: 'Error loading user report',
            position: 'top'
          })
        })
    },
    closeModal() {
      this.showModal = false
      this.selectedUser = null
    },
    formatUserWithDays(user) {
      let totalRecessDays = user.recessDays.reduce((acc, current) => acc + current.days, 0)
      let totalDaysRequested = user.recessRequests.reduce((acc, current) => acc + current.lines.length, 0)
			let totalVacationsDays = user.recessRequests.reduce((acc, current) => acc + (current.type == 0 ? current.lines.length : 0), 0)
      let availableDays = totalRecessDays - totalVacationsDays
      return {
        ...user,
        totalRecessDays,
        totalDaysRequested,
        availableDays,
        totalVacationsDays,
      }
    },
    getTypeName(typeId) {
      const type = this.types.find(t => t.id === typeId)
      return type ? type.name : ''
    },
    getTypeColor(typeName) {
      if (!typeName) return ''
      if (typeName.toLowerCase().includes('vacation')) return 'blue lighten-4'
      if (typeName.toLowerCase().includes('paid leave')) return 'purple lighten-4'
      if (typeName.toLowerCase().includes('unpaid leave')) return 'orange lighten-4'
      return 'grey lighten-4'
    }
  },
}
</script>
<style scoped lang="scss">
.v-menu__content {
  border-radius: 12px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: 2px solid var(--v-lightgray-lighten) !important;
}
.input{
  margin-left: 15px;
  margin-top: 0;
}
</style>